import { getCallunProCount } from '@/api/login'
export default {
  namespaced: true,
  state: {
    //Calling 拨打待接听
    //Answer 接听待响应
    //Pending 通话中
    //RingOff 挂断中（初始状态）
    //Accept 外呼对方接听
    //RingOn 外呼对方振铃状态
    tcccStatus: 'RingOff',
    tcccUserInfo: {
      header: '',
      name: '',
      userType: '',
      phone: ''
    },
    unProcessCallNum: 0, // 虚拟电弧未处理总数
    timerRun: false, // 通话计时器状态
    cdrId: '' // 通话记录id
  },
  mutations: {
    SET_CDR_ID(state, id) {
      state.cdrId = id
    },
    SET_TCCC_STATUS(state, STATUS) {
      state.tcccStatus = STATUS || 'RingOff'
    },
    SET_TCCC_USERINFO(state, USERINFO) {
      state.tcccUserInfo = USERINFO
    },
    SET_UNPROCESS_CALL_NUM(state, num) {
      state.unProcessCallNum = num
    },
    SET_TIMER_RUN(state, STATUS) {
      state.timerRun = STATUS
    }
  },
  actions: {
    getCallunProcessedCount({ commit }) {
      getCallunProCount().then(res => {
        commit('SET_UNPROCESS_CALL_NUM', res)
      })
    }
  }
}
